import { render, staticRenderFns } from "./SettingsDefaults.vue?vue&type=template&id=0919164a"
import script from "./SettingsDefaults.vue?vue&type=script&lang=js"
export * from "./SettingsDefaults.vue?vue&type=script&lang=js"
import style0 from "./SettingsDefaults.vue?vue&type=style&index=0&id=0919164a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports